import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Image loading utilities
export function handleImageError(
  e: React.SyntheticEvent<HTMLImageElement, Event>,
  fallbackSrc?: string,
  onError?: () => void
) {
  const target = e.currentTarget;

  if (fallbackSrc && target.src !== fallbackSrc) {
    target.src = fallbackSrc;
  } else {
    // Instead of hiding, show a placeholder with proper styling
    target.style.background = "linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)";
    target.style.display = "flex";
    target.style.alignItems = "center";
    target.style.justifyContent = "center";
    target.style.color = "#6b7280";
    target.style.fontSize = "12px";
    target.style.fontWeight = "500";
    target.alt = target.alt || "Image not available";
    console.warn(`Failed to load image: ${target.src}`);
    onError?.();
  }
}

export function getImageUrl(path: string) {
  // Ensure image path starts with /assets/images/
  if (path.startsWith("http")) return path;
  if (path.startsWith("/assets/")) return path;
  if (path.startsWith("assets/")) return `/${path}`;
  return `/assets/images/${path}`;
}

// Create a default fallback image URL
export function getImageWithFallback(primarySrc: string, fallbackSrc?: string): string {
  return primarySrc || fallbackSrc || "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Crect width='100' height='100' fill='%23f3f4f6'/%3E%3Ctext x='50' y='50' text-anchor='middle' dy='.3em' fill='%236b7280' font-size='12'%3ENo Image%3C/text%3E%3C/svg%3E";
}
